import { useState } from "react";
import InputIcon, { InputIconProps } from "./InputIcon";

import {
    AiOutlineUser,
    AiOutlineMail,
    AiOutlineEyeInvisible,
    AiOutlineEye,
} from "react-icons/ai";

//Common icons
const UserInput: React.FC<InputIconProps> = (props) => {
    return <InputIcon {...props} icon={AiOutlineUser} />;
};


const PasswordInput: React.FC<InputIconProps> = (props) => {
    const [type, setType] = useState<string>("password");
    const handleChange = () => {
        setType((prev) => (prev === "password" ? "text" : "password"));
    };
    return (
        <InputIcon
            {...props}
            icon={type === "password" ? AiOutlineEyeInvisible : AiOutlineEye}
            type={type}
            onIconClick={handleChange}
        />
    );
};

const EmailInput: React.FC<InputIconProps> = (props) => {
    return <InputIcon {...props} icon={AiOutlineMail} type="email" />;
};

export { InputIcon, UserInput, PasswordInput, EmailInput };
